<template>
    <div id="result-chart-co2-container" class="table-container relative" :style="bannerStyle">
        <h2>THG-Emissionen</h2>
        <div class="flex items-center">
            <div class="w-2/12 font-bold text-sm"></div>
            <div class="w-10/12"><h3>THG-Emissionen in kg/a</h3></div>
        </div>
        <div id="co2-chart">
            <div class="flex items-center chart-section chart-section-start">
                <div class="w-2/12 font-bold text-sm variant-label"></div>
                <div class="w-10/12">
                    <div class="chart-container">
                        <div v-for="stepIndex in (steps + 1)" class="y-axes" :style="'left: ' + ((stepIndex - 1) * columnWidth) + '%'">
                            <div class="axes-label flex items-center justify-center lining-nums tabular-nums">
                                {{ formatValue((stepIndex - 1) * chartCo2.steps, 'step') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template v-for="(chartData, chartIndex) in chartCo2.charts">
                <div class="flex items-center chart-section" :class="[chartIndex == 0 ? 'first' : (chartIndex == (chartCo2.charts.length -1) ? 'last' : '')]">
                    <div class="w-2/12 font-bold text-xs variant-label">
                        {{ chartData.name }}
                    </div>
                    <div class="w-10/12">
                        <div class="chart-container">
                            <div v-for="stepIndex in (steps + 1)" class="y-axes" :style="'left: ' + ((stepIndex - 1) * columnWidth) + '%'">
                                <div class="axes-label flex items-center justify-center hidden lining-nums tabular-nums">
                                    {{ formatValue((stepIndex - 1) * chartCo2.steps, 'step') }}
                                </div>
                            </div>
                            <div class="char-bar main-char-bar" :data-summe="chartData.summe" :style="'width: ' + getBarWidth(chartData) + '%;'">
                                <div class="char-index whitespace-nowrap pointer-events-none lining-nums tabular-nums flex items-center">
                                    {{ formatValue(chartData.index, 'index', '%') }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <div class="flex items-center chart-section chart-section-end">
                <div class="w-2/12 font-bold text-sm variant-label"></div>
                <div class="w-10/12">
                    <div class="chart-container">
                        <div v-for="stepIndex in (steps + 1)" class="y-axes" :style="'left: ' + ((stepIndex - 1) * columnWidth) + '%'">
                            <div class="axes-label flex items-center justify-center lining-nums tabular-nums">
                                {{ formatValue((stepIndex - 1) * chartCo2.steps, 'step') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex items-center mb-10">
            <div class="w-2/12 h-5">
            </div>
            <div class="flex flex-nowrap w-10/12 pt-4">
                <div class="flex items-center w-3/12 pr-4"><div class="chart-label-color w-8 h-4 mr-2" style="background-color: #333333;"></div><div class="text-xs"><div class="font-bold text-base" data-v-e79df86e="">THG-Emissionen</div></div></div>
            </div>
        </div>
    </div>
</template>

<script>

import {getCurrentInstance} from "vue";

export default {
    props: {
        chartCo2: {
            type: Object,
            required: false,
            default: {}
        }
    },
    computed: {
        chartHeight() {

            const chartHeight = (this.chartPaddingY * 2) + this.barHeight;
            return chartHeight;
        },
        barHeight() {
            return 30
        },
        chartPaddingY() {
            return 40
        },
        bannerStyle() {
            return {
                '--chart-height': `${this.chartHeight}px`,
                '--chart-height-2': `${(this.chartHeight + this.chartPaddingY)}px`,
                '--bar-height': `${this.barHeight}px`,
                '--chart-padding-y': `${this.chartPaddingY}px`,
                '--chart-padding-y-2': `${(this.chartPaddingY * 2)}px`,
                '--chart-border-color': '#dddddd'
            }
        }
    },
    setup(props) {
        const internalInstance = getCurrentInstance();
        const accounting = internalInstance.appContext.config.globalProperties.$accounting;

        const chartCo2 = props.chartCo2;

        const steps = (chartCo2.max / chartCo2.steps);
        const columnWidth = 100 / steps;

        const getBarWidth = (charData) => {

            return (100 * charData.summe) / chartCo2.max
        }

        const formatValue = (value, row, unit) => {
            if (value == '-') return value;
            if (['energieeffizienzklasse_endenergiebedarf'].includes(row)) return value;

            var precision = 2;
            if (['step','index'].includes(row)) precision = 0

            return accounting.formatMoney(value, {
                symbol: '',
                format: '%v',
                precision: precision,
                decimal: ',',
                thousand: '.'
            }) + (unit ? ' ' + unit : '');

        }

        return {
            chartCo2,
            steps,
            columnWidth,
            getBarWidth,
            formatValue
        }
    },
}
</script>

<style lang="scss" scoped>
#co2-chart {
    margin: 20px 0;
    padding: 30px 0;
}

.char-bar {
    position: absolute;
    left: 0;
}

.char-index {
    position: absolute;
    width: 0;
    height: 100%;
    right: -10px;
    font-size: 10px;

}

.main-char-bar {
    top: var(--chart-padding-y);
    height: var(--bar-height);
    background-color: #333333;
}

.y-axes {
    position: absolute;
    /*height: var(--chart-height);*/
    bottom: 0;
    top: 0;
    width: 1px;
    background-color: var(--chart-border-color);

    .axes-label {
        pointer-events: none;
        position: absolute;
        width: 30px;
        margin-left: -15px;
        height: 0;
        font-size: 10px;
        text-align: center;
    }
}


.chart-section {
    .variant-label{
        padding-right: 10px;
    }
    .chart-container {
        position: relative;
        height: var(--chart-height);
    }

    &.chart-section-start {
        .chart-container {
            border-bottom: 1px solid var(--chart-border-color);
            height: 20px;

            .axes-label {
                height: 30px;
                top: -30px;

            }
        }
    }

    &.chart-section-end {
        .chart-container {
            border-top: 1px solid var(--chart-border-color);

            height: 20px;

            .axes-label {
                height: 30px;
                bottom: -30px;
            }
        }
    }

    &.first {
        .variant-label{ margin-top: var(--chart-padding-y) }
        .chart-container {
            .main-char-bar {
                top: var(--chart-padding-y-2);
            }
            height: var(--chart-height-2);
        }
    }

    &.last {
        .chart-container {
            height: var(--chart-height-2);
        }
    }

}

</style>
